import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { Router } from './Router';
import { theme } from './theme';
import './App.css';
import "mapbox-gl/dist/mapbox-gl.css";

export default function App() {
  return (
    <div id="main-container">
      <MantineProvider theme={theme}>
        <Notifications position="top-center" zIndex={10_000} />
        <Router />
      </MantineProvider>
    </div>
  );
}
